import React from "react";
import PropTypes from "prop-types";
import MocksetNavItem from "./MocksetNavItem";
import ITTestNavItem from "./ITTestNavItem";
import LoadObject from "data/LoadObject";
import ITTestHistoryStore from "data/dev/ITTestHistoryStore";

const DevNavItems = props =>
    <React.Fragment>
        <MocksetNavItem mocksetLO={props.mocksetLO} activeMockset={props.activeMockset} />
        <ITTestNavItem itTestLO={props.itTestLO} activeTest={props.activeTest} history={props.history} />
    </React.Fragment>;

DevNavItems.propTypes = {
    activeTest: PropTypes.string,
    itTestLO: PropTypes.instanceOf(LoadObject),
    activeMockset: PropTypes.string,
    mocksetLO: PropTypes.instanceOf(LoadObject),
    history: ITTestHistoryStore.constructor.stateTypes, // this is questionable.
};

export default DevNavItems;



// WEBPACK FOOTER //
// ./app/views/dev/DevNavItems.js